import React from 'react';
import { semantic } from '../../ui/theme';
import { BRAND_NO_TRANSLATE_PROPS } from '../../utils/branding/brandNoTranslate';

const SIZE_MAP = {
  sm: '0.875rem',
  md: '1rem',
  lg: '1.125rem',
  xl: 'clamp(2rem, 2.6vw, 2.4rem)',
  '2xl': '2.2rem',
};

export default function BrandLogo({
  size = 'md',
  fontSize: fontSizeOverride,
  crewColor = 'inherit',
  vexColor = semantic.brand.logoVex,
  style,
}) {
  const resolvedSize = fontSizeOverride || SIZE_MAP[size] || SIZE_MAP.md;

  return (
    <span
      {...BRAND_NO_TRANSLATE_PROPS}
      data-testid="brand-logo"
      style={{
        fontFamily: "'Bricolage Grotesque', sans-serif",
        fontWeight: 700,
        fontSize: resolvedSize,
        letterSpacing: '-0.03em',
        lineHeight: 1.1,
        display: 'inline-flex',
        whiteSpace: 'nowrap',
        ...style,
      }}
    >
      <span style={{ color: crewColor }}>Crew</span>
      <span style={{ color: vexColor }}>Vex</span>
    </span>
  );
}
